/**
 * @generated SignedSource<<788c4604845c8971906b10f898dadcbf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsProviderNamespace = "ASAP" | "CLASSIC" | "FORGE" | "OAUTH" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_MoreMenu$data = {
  readonly devInfoProviders: ReadonlyArray<{
    readonly __typename: "DevOpsDevInfoProvider";
    readonly id: string;
    readonly name: string | null | undefined;
    readonly namespace: DevOpsProviderNamespace | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "main_softwareCodePage_MoreMenu";
};
export type main_softwareCodePage_MoreMenu$key = {
  readonly " $data"?: main_softwareCodePage_MoreMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_MoreMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_softwareCodePage_MoreMenu",
  "selections": [
    {
      "concreteType": "DevOpsDevInfoProvider",
      "kind": "LinkedField",
      "name": "devInfoProviders",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "RequiredField",
          "field": {
            "kind": "ScalarField",
            "name": "id"
          },
          "action": "THROW",
          "path": "devInfoProviders.id"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "namespace"
        }
      ]
    }
  ],
  "type": "DevOpsProviders"
};

(node as any).hash = "21e48de7c26614d1e27f342ce1e89028";

export default node;
